import React from "react";
import { useTranslation } from "react-i18next";
import { Input } from "components/bootstrap";
function MongoDBDataAdapterFieldSet({ config, handleFormEvent }) {
  const { t } = useTranslation("enterprise_lookup");
  return /* @__PURE__ */ React.createElement("fieldset", null, /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "checkbox",
      id: "cidr_lookup",
      name: "cidr_lookup",
      label: t("adapter_fields.cidr_lookup"),
      checked: config.cidr_lookup,
      onChange: handleFormEvent,
      help: t("adapter_fields.help_cidr_lookup"),
      wrapperClassName: "col-md-offset-3 col-md-9"
    }
  ));
}
export default MongoDBDataAdapterFieldSet;
